<template>
    <div class="mydetail-wrap">
<!--        <div class="mydetail-top-menu">-->
<!--          <button :class="{'menu-focus' : tabMenu==='gift'}" @click.prevent="tabMenu='gift'">선물내역<h2 class="blind" v-if="tabMenu==='gift'">선택됨</h2></button>-->
<!--        </div>-->
        <award-detail-gift v-if="tabMenu==='gift'"/>
        </div>
</template>

<script>
import awardDetailGift from "@/views/award/awardDetailGift";
export default {
    name: 'awardDetail',
    components: { awardDetailGift },
    data () {
        return {
          tabMenu: "gift"
        }
    },
    mounted() {
        this.$heading('시상내역')
    },
    methods: {
    }
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/pages/myemarticon/myDetail.scss';
</style>